import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base styling
          'flex h-10 w-full rounded-md px-3 py-2 text-sm',
          // Background with depth
          'bg-abyss-dark/60 backdrop-blur-sm',
          // Border with glow on focus
          'border border-border/50',
          'focus:border-biolume-cyan/50 focus:shadow-[0_0_10px_rgba(34,211,238,0.2)]',
          // Inner shadow for depth
          'shadow-[inset_0_1px_3px_rgba(0,0,0,0.3)]',
          // Text styling
          'text-foreground placeholder:text-muted-foreground/60',
          // File input styling
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
          // Focus ring
          'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-biolume-cyan/50',
          // Disabled state
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/30',
          // Transition
          'transition-all duration-200',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
